import { render, staticRenderFns } from "./ConfiguracionPuntos.vue?vue&type=template&id=e03ae84c"
import script from "./ConfiguracionPuntos.vue?vue&type=script&lang=js"
export * from "./ConfiguracionPuntos.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracionPuntos.vue?vue&type=style&index=0&id=e03ae84c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports